export const hasCheckInState = (item) => Boolean(item?.checkInRequired || item?.checkInDone);

export const isCheckInSectionVisible = (eventData) => {
  return hasCheckInState(eventData) && !eventData?.isInformationBooking;
};
